import { createRequest } from '../helpers/api_utils';
import { apiUrl } from './api_url';

const base = `${apiUrl}/auth/mfa`;

export function verifyMfa(challengeToken: string, opts: { code?: string; recoveryCode?: string }) {
  return fetch(createRequest(`${base}/verify`, 'POST', 'application/json', false, { challengeToken, ...opts }));
}
// A forced enrolment (enrollToken from login/SSO) identifies the user by that
// token alone: no bearer is sent, so a leftover session in the tab can never
// enrol the wrong account. In-app enrolment uses the session bearer.
export function enrollBegin(body: { enrollToken?: string; code?: string }) {
  return fetch(createRequest(`${base}/enroll/begin`, 'POST', 'application/json', !body.enrollToken, body));
}
export function enrollConfirm(body: { enrollmentId: string; code: string; enrollToken?: string }) {
  return fetch(createRequest(`${base}/enroll/confirm`, 'POST', 'application/json', !body.enrollToken, body));
}
export function mfaStatus() {
  return fetch(createRequest(`${base}/status`, 'GET', 'application/json', true));
}
export function mfaDisable(code: string) {
  return fetch(createRequest(`${base}/disable`, 'POST', 'application/json', true, { code }));
}
export function regenerateRecoveryCodes(code: string) {
  return fetch(createRequest(`${base}/recovery-codes/regenerate`, 'POST', 'application/json', true, { code }));
}
export function adminResetMfa(orgUserId: string) {
  return fetch(createRequest(`${base}/admin/reset`, 'POST', 'application/json', true, { orgUserId }));
}
export function getAuthSettings() {
  return fetch(createRequest(`${apiUrl}/organization/auth-settings`, 'GET', 'application/json', true));
}
export function putAuthSettings(body: {
  passwordLoginEnabled: boolean;
  mfaPolicy: string;
  sso?: Record<string, unknown>;
  removeSso?: boolean;
}) {
  return fetch(createRequest(`${apiUrl}/organization/auth-settings`, 'PUT', 'application/json', true, body));
}

export function testSso() {
  return fetch(createRequest(`${apiUrl}/organization/auth-settings/sso/test`, 'POST', 'application/json', true));
}
